import { Flex, Select, useToast } from '@chakra-ui/react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { useEffect, useRef, useState } from 'react'
import { CircleFlag } from 'react-circle-flags'
import G2Promotion from '../../assets/images/promotions/G2PromotionalBanner.svg'
import { emailType } from '../../data/emailType'
import useCheckLimit from '../../hooks/useCheckLimit'
import Button from '../Button/Button'
import DocPage from '../DocPage/DocPage'
import Rating from '../Rating/Rating'
import { SelectMenu } from '../SelectMenu'
import CSS from './styles.module.css'
import useKeyGenerate from '../../hooks/useKeyGenerate'
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT

const IslandContainer = ({ resultVal, limitSet }) => {
  // ChakraUI Toast
  const toast = useToast()
  const keyword = useKeyGenerate()

  // Refs
  const ETypeBox = useRef(null)

  // Generated Results logic
  const [result, setResult] = useState(0)
  const limitExceeded = useCheckLimit()

  // Email Template
  const [EMdata, setEMdata] = useState('')

  // Form Data & their handlers
  const [EType, setEType] = useState('')
  let lang = 'Eng (US)'

  const ETypeHandler = (e) => {
    if (ETypeBox.current.value !== '') {
      setEType(e.currentTarget.value)
    }
  }

  const langChangeHandler = (e) => {
    if (e !== '') {
      lang = `${e}`
    }
  }

  const increaseLimitCount = () => {
    let count = Cookies.get('genCount')
    if (!count) {
      Cookies.set('genCount', '1', {
        expires: 1,
      })
    } else {
      count = parseInt(count) + 1
      Cookies.set('genCount', count.toString(), {
        expires: 1,
      })
    }
  }

  // API Call
  const fetchResult = async () => {
    if (!limitExceeded) {
      if (EType !== '') {
        const emailType = `${EType}. Generate Email templates in ${lang} Language with proper email formatting. Show only the Email body as output. Don't include any images, tables and unnecessary empty lines.`

        setEMdata('')

        setResult(1)

        increaseLimitCount()

        setTimeout(() => {
          setResult(2)
        }, 100)
        const header = {
          Authorization: `Bearer ${keyword}`,
        }
        await axios
          .post(
            API_ENDPOINT,
            {
              emailType,
            },
            { headers: header }
          )
          .then((res) => {
            if (res && res.data && res.data.choices) {
              setEMdata(res.data.choices[0].message.content)
            }

            setTimeout(() => {
              setResult(3)
            }, 100)
          })
          .catch((err) => {
            console.error(err)
            setTimeout(() => {
              setResult(2)
              setTimeout(() => {
                setResult(1)
              }, 100)
              toast({
                title: 'Oops!',
                description: 'Something went wrong. Try again.',
                status: 'error',
                duration: 5000,
                isClosable: true,
                position: 'bottom-left',
              })
            }, 53000)
          })
      } else {
        toast({
          description: 'Please fill out Job Title field. (Required)',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'bottom-left',
        })
      }
    } else {
      limitSet(true)
    }
  }

  useEffect(() => {
    setTimeout(() => {
      ETypeBox.current.focus()
    }, 1500)
  }, [])

  useEffect(() => {
    setEType(ETypeBox.current.value)
  }, [ETypeBox.current])

  useEffect(() => {
    resultVal(result)
  }, [result, resultVal])

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      width="100%"
      style={{ position: 'relative', padding: '0px 15px' }}
    >
      <div
        className={`${CSS.IslandContainer} ${
          result === 2 ? CSS.IC_Progress : ''
        } ${result === 3 ? CSS.IC_expanded : ''}`}
      >
        <div
          className={`${CSS.InputGrid} ${
            result === 2 || result === 3 ? CSS.IG_Progress : ''
          }`}
        >
          <Select
            variant="filled"
            placeholder="Select Email Type"
            height="50px"
            onChange={ETypeHandler}
            ref={ETypeBox}
            required
          >
            {emailType.map((type, index) => (
              <option key={index} value={`${type} Email`}>
                {`${type} Email`}
              </option>
            ))}
          </Select>
          <SelectMenu
            placeholder="Language"
            outputValue={langChangeHandler}
            defaultValue={lang}
            className={CSS.LangSelect}
            optionalLabel
          >
            <span>
              <CircleFlag countryCode="us" /> Eng (US)
            </span>
            <span>
              <CircleFlag countryCode="uk" /> Eng (UK)
            </span>
            <span>
              <CircleFlag countryCode="es" /> Spanish
            </span>
            <span>
              <CircleFlag countryCode="de" /> German
            </span>
            <span>
              <CircleFlag countryCode="fr" /> French
            </span>
            <span>
              <CircleFlag countryCode="it" /> Italian
            </span>
            <span>
              <CircleFlag countryCode="sa" /> Arabic
            </span>
            <span>
              <CircleFlag countryCode="nl" /> Dutch
            </span>
            <span>
              <CircleFlag countryCode="pt" /> Portugese
            </span>
            <span>
              <CircleFlag countryCode="pl" /> Polish
            </span>
          </SelectMenu>
          <Button
            variant="HeroButton"
            className={CSS.HeroButton}
            leftIcon="bolt"
            onClick={fetchResult}
            disabled={
              result === 3 || result === 1 || result === 0 ? false : true
            }
          >
            {result === 2
              ? 'Generating...'
              : result === 3
              ? 'Regenerate'
              : 'Generate'}
          </Button>
        </div>

        <div
          className={`${CSS.Results} ${
            result === 2 ? CSS.ResultsInprogress : ''
          } ${result === 3 ? CSS.ResultsComplete : ''} ${
            result === 0 ? CSS.ResultsHidden : ''
          }`}
        >
          <div className={CSS.IconIllustration}>
            <div className={CSS.ProcessingIcon}>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle1}`}></div>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle2}`}></div>
              <div className={`${CSS.Sparkles} ${CSS.Sparkle3}`}></div>
            </div>
            <div className={CSS.Steps}>
              <div className={CSS.step}></div>
              <div className={CSS.step}></div>
              <div className={CSS.step}></div>
            </div>
          </div>

          <font>
            Generating your top-class Email Template. It may take upto 10
            seconds.
          </font>
        </div>

        {result === 3 && (
          <div className={CSS.PromotionBanner}>
            <a
              href="https://dash.recooty.com/register?referral=ultra&http_referer=https%3A%2F%2Fdash.recooty.com%2F"
              target="_blank"
            >
              <img
                src={G2Promotion}
                alt="Free Job description Generator Banner Ad"
              />
            </a>
          </div>
        )}

        <DocPage isActive={result === 3} lang={lang}>
          {EMdata}
        </DocPage>
      </div>
      <div className={CSS.HighlightPoints}>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Time Saving
        </div>
        <div className={CSS.Separator}></div>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Professional tone
        </div>
        <div className={CSS.Separator}></div>
        <div className={CSS.Point}>
          <span className="material-symbols-outlined">task_alt</span>
          Ready to use
        </div>
      </div>
      <Rating
        comment={
          <font>
            Thanks to this AI Email Writing tool, crafting emails for the entire
            candidate journey is swift and seamless. Our communication with
            candidates has vastly improved, ensuring timely responses
            <br />
            and enhancing their overall experience. A game-changer!
          </font>
        }
        person="Sabastian Richardson"
        company="Recruiter"
        className={`${CSS.Rating} ${
          result === 0 ? CSS.RatingInit : CSS.RatingOff
        }`}
      />
    </Flex>
  )
}

export default IslandContainer
